export default __webpack_public_path__ + "static/media/image-42.a43fb0bd.png";